<template>
  <div v-if="text" class="support-banner" role="status">
    <span class="support-banner__text">{{ text }}</span>
    <button type="button" class="support-banner__end" :disabled="ending" @click="end">접속 끝내기</button>
  </div>
</template>
<script>
// 지원 탭 배너(계약 SUPPORT 5·RULES SUPPORT 7): 진입한 사람의 탭에 늘, 닫기 버튼 없음. [접속 끝내기] = POST /auth/support/end
import apiInstance from "@/axios";
import { isSupportTab, isSupportEnded, getSupportSession, endSupportTab } from "@/utils/tokenStore";
import { supportBannerText, supportEndedUrl, supportProbe, SUPPORT_PROBE_MS, supportActivityReporter, SUPPORT_ACTIVITY_EVENTS } from "@/utils/supportSession";

export default {
  name: "SupportBanner",
  data() {
    // 지원 탭인지는 탭이 열릴 때 정해지고(교환 뒤 새로 고침), 끝나면 끝 화면으로 떠남 — 반응형 값이 필요 없음
    return { text: isSupportTab() && !isSupportEnded() ? supportBannerText(getSupportSession()) : "", ending: false };
  },
  watch: {
    text: {
      immediate: true,
      handler(value) {
        document.body.classList.toggle("support-mode", !!value);
      },
    },
  },
  mounted() {
    // 가만히 있는 탭도 동의 철회·잠금 뒤 끝 화면으로(끝났으면 axios 응답 처리기가 끝 화면으로 보냄)
    if (this.text) this.probeTimer = setInterval(() => supportProbe((url, config) => apiInstance.get(url, config)), SUPPORT_PROBE_MS);
    // 사람이 누르거나 입력할 때만 쉬는 시간(30분)을 되돌림
    if (this.text) {
      this.reportActivity = supportActivityReporter((url, body, config) => apiInstance.post(url, body, config));
      SUPPORT_ACTIVITY_EVENTS.forEach((e) => window.addEventListener(e, this.reportActivity, { capture: true, passive: true }));
    }
  },
  beforeUnmount() {
    clearInterval(this.probeTimer);
    if (this.reportActivity) SUPPORT_ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, this.reportActivity, { capture: true }));
  },
  methods: {
    async end() {
      this.ending = true;
      try {
        await apiInstance.post("/auth/support/end", null, { showErrorNotice: false });
      } catch (error) {
        // 서버가 이미 끝냈거나 연결이 안 돼도 이 탭은 끝난 지원 탭으로 묶는다(토큰은 15분 뒤 만료)
      }
      endSupportTab("USER");
      window.location.replace(supportEndedUrl("USER"));
    },
  },
};
</script>
<style>
/* 배너 높이만큼 화면을 내림(사이드 메뉴가 position: fixed 라 같이 내림) */
body.support-mode {
  padding-top: 36px;
}
body.support-mode .fixed-start {
  top: 36px !important;
}
</style>
<style scoped>
.support-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 16px;
  background: #b42318;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.support-banner__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.support-banner__end {
  flex: none;
  border: 1px solid #fff;
  border-radius: 4px;
  background: transparent;
  color: #fff;
  padding: 2px 12px;
  cursor: pointer;
}
.support-banner__end:disabled {
  opacity: 0.6;
  cursor: default;
}
</style>
